import {useEffect, useCallback, useRef} from '@wordpress/element';
import {usePaymentMethodDataContext} from "../../context";

export const useHandleTokenization = ({venmoInstance, onSubmit}) => {
    const paymentData = useRef(null);
    const {
        onPaymentDataFilter
    } = usePaymentMethodDataContext();

    useEffect(() => {
        const unsubscribe = onPaymentDataFilter(async (data, {nonceKey, gatewayId}) => {
            const result = await venmoInstance.tokenize();
            data.meta.paymentMethodData[nonceKey] = result.nonce;
            paymentData.current = {nonce: result.nonce};
            return data;
        }, 5);
        return () => unsubscribe();
    }, [venmoInstance, onPaymentDataFilter]);

    return {};
}

export default useHandleTokenization;